<template>
  <div class="hello">
    
    <b-navbar type="light" variant="light" toggleable = "sm">

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
      <b-navbar-nav>
        <b-nav-item-dropdown text="People">
          <b-dropdown-item to="/people">Everyone</b-dropdown-item>
          <b-dropdown-item href="#">All signed in now</b-dropdown-item>
          <b-dropdown-item
            v-if="routeName == 'people' || routeName == 'personDetail'"
            v-b-modal.person-create
            >Add new person</b-dropdown-item
          >
          <b-dropdown-item
            v-if="routeName == 'personDetail'"
            :to="{name:'addResponsiblePerson'}"
            >Add Parent / Gaurdian</b-dropdown-item
          >
          <b-dropdown-item
            v-if="routeName == 'personDetail'"
            :to="{name:'deletePerson'}"
            >Delete This Person</b-dropdown-item
          >
          <b-dropdown-item to ="/staff-operated-signin">Sign People In</b-dropdown-item>
        </b-nav-item-dropdown>
        </b-navbar-nav>

      <b-collapse id="nav-collapse" is-nav>
      <b-navbar-nav>
        <!--b-nav-item to="/">Home</b-nav-item-->

        

        <b-nav-item to="/reports">Reports</b-nav-item>

        <b-nav-item-dropdown text="Projects">
          <b-dropdown-item to="/projects">Projects</b-dropdown-item>
          <b-dropdown-item to="/projects/newproject"
            >Add new projects</b-dropdown-item
          >
        </b-nav-item-dropdown>
        <b-nav-item to="/login">Log Out</b-nav-item>
      </b-navbar-nav>
      </b-collapse>

      <!-- right aligned items-->
      <b-navbar-nav class="ml-auto">
        <font-awesome-icon
          icon="search"
          size="lg"
          v-b-modal.modal-search
          style="color:#a2a2a2; cursor:pointer "
        ></font-awesome-icon>
      </b-navbar-nav>
      <b-navbar-brand>
        <!--img
          src="../assets/YI_Logo.jpg"
          height="40"
          width="90"
          class="d-inline-block align-top"
          alt="Kitten"
        /-->
        <b-img :src = "urlPrefix + '/static/img/LogoTightCrop.gif'"  height="40" width="90" alt="whoops its not there !"></b-img>
      </b-navbar-brand>
    </b-navbar>
    
    <b-alert
      v-model="showAlert"
      variant="danger"
      dismissible
      @dismissed="dismissError"
    >
      {{ error }}
    </b-alert>
  </div>
</template>

<script>
export default {
  name: "Navbar",
  props: {
    msg: String,
  },

  computed: {
    error() {
      return this.$store.getters.axiosError;
    },
    routeName() {
      return this.$route.name;
    },
    urlPrefix(){
      return this.$store.getters.urlPrefix;
    },
  },

  watch: {
    error: function() {
      if (this.error != null) {
        this.showAlert = true;
        return;
      }
      this.showAlert = false;
    },
  },

  methods: {
    dismissError() {
      this.$store.dispatch("axiosError", null);
    },
  },

  data() {
    return {
      showAlert: false,
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
